import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, EnvelopeIcon, PhoneIcon, MapPinIcon } from '@heroicons/react/24/outline';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Formulário enviado:', formData);
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-custom py-12">
        <Link to="/" className="inline-flex items-center text-medical-600 hover:text-medical-700 mb-8">
          <HomeIcon className="w-5 h-5 mr-2" />
          Voltar para Home
        </Link>

        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gradient">Entre em Contato</h1>
            <p className="text-xl text-gray-600">
              Estamos aqui para ajudar. Envie sua mensagem e responderemos em breve.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="card text-center">
              <EnvelopeIcon className="w-12 h-12 text-medical-600 mx-auto mb-4" />
              <h3 className="font-semibold text-lg mb-2">E-mail</h3>
              <a href="mailto:info@onmniai.com" className="text-medical-600 hover:underline">
                info@onmniai.com
              </a>
            </div>

            <div className="card text-center">
              <PhoneIcon className="w-12 h-12 text-health-600 mx-auto mb-4" />
              <h3 className="font-semibold text-lg mb-2">Telefone</h3>
              <p className="text-gray-600">+55 (11) 9999-9999</p>
            </div>

            <div className="card text-center">
              <MapPinIcon className="w-12 h-12 text-tech-600 mx-auto mb-4" />
              <h3 className="font-semibold text-lg mb-2">Localização</h3>
              <p className="text-gray-600">São Paulo, Brasil</p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
            {!submitted ? (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-medical-500 focus:border-transparent"
                      placeholder="João Silva"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      E-mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-medical-500 focus:border-transparent"
                      placeholder="joao@exemplo.com"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                    Assunto *
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-medical-500 focus:border-transparent"
                  >
                    <option value="">Selecione um assunto</option>
                    <option value="sales">Vendas e Planos</option>
                    <option value="support">Suporte Técnico</option>
                    <option value="partnership">Parcerias</option>
                    <option value="other">Outro</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Mensagem *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-medical-500 focus:border-transparent"
                    placeholder="Descreva como podemos ajudar..."
                  />
                </div>

                <button type="submit" className="btn-primary w-full">
                  Enviar Mensagem
                </button>
              </form>
            ) : (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-health-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-health-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">Mensagem Enviada!</h3>
                <p className="text-gray-600 mb-8">
                  Obrigado pelo contato. Nossa equipe responderá em até 24 horas.
                </p>
                <Link to="/" className="btn-primary inline-block">
                  Voltar para Home
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
